import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards8 from "./Cards_8";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

/*<div className="">
<animated.div
        class="card6"
        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
        onMouseLeave={() => set({ xys: [0, 0, 1] })}
        style={{ transform: props.xys.interpolate(trans) , backgroundImage:  'url("./pictures/images_17.jpg")' }}    
/> 

</div>*/

function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }
  
  return (
    <div className="">



        <div   id = "signal-report"    className="card-6" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   >
        <br></br>
          <a     id ="Strategy" aria-expanded="false" ><img className=""  width="170px" height="70px" src="./pictures/images_9.jpg"></img><span className="doc-content-title">Technology</span></a>
                            <div className="wrapper_line"></div>

                            <br></br>

                  <p id="page_summary_id" className="page_summary_id">

                  <span>Our platform is built on cutting-edge technologies and modern cloud-native infrastructure designed to deliver scalability, performance, security, and operational resilience.</span>
                  <span>Leveraging advanced client-server architecture (CSA) and high-level IT migration strategies, the ecosystem is engineered to support complex investment and market-intelligence workflows across distributed environments </span>
                  <span>The infrastructure integrates modern web technologies, real-time data processing pipelines, and scalable cloud services provided by industry-leading cloud providers to ensure reliability, flexibility, and continuous system evolution. </span>
                  <br></br>    

                  
                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
 
                  </p>
                  <br></br>
            
                  <Cards8 />
                  <br></br>
         

        </div>

</div>

  )
};

export default Card; 


